import { React } from 'react';
import './disclaimers.scss';
// import { DisclaimerText } from "../../assets/markdowns/disclaimer-page-disclaimer.md";

//TODO: use something like markdown-it or react-markdown to convert this from the markdown file to HTML
const DisclaimerText = {
  __html :
  `
  <p tabIndex="0">Goldman Sachs International Bank acts as the Operator of SIGMA X MTF. Goldman Sachs International, an affiliate of Goldman Sachs International Bank may also from time to time be a Participant of SIGMA X MTF, subject to satisfying the eligibility criteria and other rules set out in the SIGMA X MTF Rulebook. Goldman Sachs has put in place internal procedures in order to manage appropriately any resulting conflicts of interest.</p>
  <p tabIndex="0">Goldman Sachs International Bank is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, and has been authorised to operate SIGMA X MTF.</p>
  <br/>
  <p tabIndex="0">Goldman Sachs Paris Inc. et Cie acts as the Operator of SIGMA X Europe MTF. Goldman Sachs International Bank Europe SE, an affiliate of Goldman Sachs Paris Inc. et Cie may also from time to time be a Participant of SIGMA X MTF, subject to satisfying the eligibility criteria and other rules set out in the SIGMA X Europe MTF Rulebook. Goldman Sachs has put in place internal procedures in order to manage appropriately any resulting conflicts of interest.</p>
  <p tabIndex="0">Goldman Sachs Paris Inc. et Cie is authorised by the Autorité de Contrôle Prudentiel et de Résolution and regulated by the Autorité de Contrôle Prudentiel et de Résolution and the Autorité des marchés financiers, and has been authorised to operate SIGMA X Europe MTF.</p>
  `
};
export const Disclaimers = ({ ...props }) => {
  return (
    <div className="disclaimers-page">
      <h1 className="disclaimers-page-title" tabIndex="0">
        Disclaimers
      </h1>
        <div 
          className="disclaimers-page-content"
          dangerouslySetInnerHTML={DisclaimerText}
        ></div>
    </div>
  );
};
